import React, { FC } from 'react';
import { ReactComponent as Dashboard } from '../../../assets/MainMenu/Dashboard.svg';

export const DashboardIcon: FC = () => <Dashboard />;
